import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/ui/button";
import { LogOut, Bell, User, Menu } from "lucide-react";
import { ROUTES } from "@/shared/config/constants";
import { useIsMobile } from "@/shared/hooks/use-mobile";
import {
  Sheet,
  SheetContent,
} from "@/shared/ui/sheet";
import { SidebarContent } from "@/widgets/sidebar/SidebarContent";

export function Header() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    // Simple logout - redirect to login for demo
    navigate(ROUTES.HOME);
  };

  return (
    <>
      <header className="flex h-16 items-center justify-between border-b bg-card px-6">
        <div className="flex items-center gap-4">
          {isMobile && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMobileMenuOpen(true)}
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}
          <h2 className="text-lg font-semibold">DDC Admin Portal</h2>
          <span className="text-xs text-muted-foreground bg-green-100 dark:bg-green-900 px-2 py-1 rounded border border-green-300 dark:border-green-700">
            🚀 CI/CD Active
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" title="Notifications">
            <Bell className="h-5 w-5" />
          </Button>
          <Button variant="ghost" size="icon" title="Profile">
            <User className="h-5 w-5" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            title="Logout"
            onClick={handleLogout}
          >
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
      </header>

      {isMobile && (
        <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
          <SheetContent side="left" className="w-64 p-0">
            <SidebarContent isExpanded={true} showHeader={true} />
          </SheetContent>
        </Sheet>
      )}
    </>
  );
}
